
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-fmv-attribute-visualizer',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './fmv-attribute-visualizer.component.html',
  styleUrl: './fmv-attribute-visualizer.component.css'
})
export class FmvAttributeVisualizerComponent implements OnInit, OnDestroy {
  @Input() type: 'adhoc' | 'live' | 'playback' = 'live';
  @Input() sensorId?: number;
  @Input() cameraSessionId?: number;
  @Input() number?: number;
  @Input() mode: 'LIVE' | 'PLAYBACK' = 'LIVE';
  @Input() startTime?: string;
  @Input() endTime?: string;
  @Input() cameraUrl?: string;
  @Input() camera?: any;

  @ViewChild('adhocVideoInput') adhocVideoInput?: ElementRef<HTMLInputElement>;
  @ViewChild('adhocImg') adhocImg?: ElementRef<HTMLImageElement>;
  @ViewChild('adhocVideo') adhocVideo?: ElementRef<HTMLVideoElement>;
  @ViewChild('httpImg') httpImg?: ElementRef<HTMLImageElement>;
  @ViewChild('httpVideo') httpVideo?: ElementRef<HTMLVideoElement>;
  @ViewChild('mainVideo') mainVideo?: ElementRef<HTMLVideoElement>;

  adhocVideoUrl: string = '';
  useImgForAdHoc = true;
  useImgForHttp = true;
  isLoading = true;
  isHttp = false;

  private hlsPlayer: any;

  ngOnInit() {
    let protocol = '';
    let directAccess = false;
    let url = this.cameraUrl;

    if (this.camera && Array.isArray(this.camera.camera) && this.camera.camera.length > 0) {
      protocol = this.camera.camera[0].protocol;
      directAccess = this.camera.camera[0].directAccess;
      url = this.camera.camera[0].url;
    }

    if (this.type !== 'adhoc' && url) {
      if (protocol === 'http' && directAccess) {
        this.isHttp = true;
        this.useImgForHttp = this.getPlayerType(url) === 'img';
        this.isLoading = false;
        this.cameraUrl = url; 
      } else {
        this.isHttp = false;
        this.isLoading = false;
       }
    }
  }

  clearUrlField() {
    this.adhocVideoUrl = '';
    if (this.adhocImg?.nativeElement) {
      this.adhocImg.nativeElement.src = '';
    }
    if (this.adhocVideo?.nativeElement) {
      this.adhocVideo.nativeElement.src = '';
    }
  }

  playAdHocVideo() {
    const url = this.adhocVideoUrl.trim();
    if (!url) {
      alert('Missing URL');
      return;
    }
    if (!url.startsWith('http')) {
      alert('Invalid URL');
      return;
    }
    const type = this.getPlayerType(url);
    if (type === 'img') {
      this.useImgForAdHoc = true;
      setTimeout(() => {
        if (this.adhocImg?.nativeElement) {
          this.adhocImg.nativeElement.src = url;
        }
      }, 300);
    } else {
      this.useImgForAdHoc = false;
      setTimeout(() => {
        if (this.hlsPlayer) {
          this.hlsPlayer.destroy();
        }
        if (this.adhocVideo?.nativeElement) {
          this.hlsPlayer = new (window as any).Hls();
          this.hlsPlayer.attachMedia(this.adhocVideo.nativeElement);
          this.hlsPlayer.loadSource(url);
        }
      }, 500);
    }
  }

  refreshHLSPlayer() {
    if (this.hlsPlayer && this.mainVideo?.nativeElement) {
      const src = this.mainVideo.nativeElement.src;
      this.hlsPlayer.destroy();
      this.hlsPlayer = new (window as any).Hls();
      this.hlsPlayer.attachMedia(this.mainVideo.nativeElement);
      this.hlsPlayer.loadSource(src);
    }
  }

  private getPlayerType(url: string): 'img' | 'video' {
    if (url.match(/\.(jpg|jpeg|png|gif|mjpg)$/i)) return 'img';
    if (url.match(/\.(mp4|webm|m3u8|flv)$/i)) return 'video';
    return 'img';
  }

  ngOnDestroy(): void {
    if (this.hlsPlayer) {
      this.hlsPlayer.destroy();
    }
  }
}